(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.qtyInput = this.querySelector('.qty__input');
      this.variantSelect = this.querySelector('.product__variant-id');
      this.optionSelects = Array.from(this.querySelectorAll('.product__select'));

      this.querySelector('[data-qty-down]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-qty-up]')?.addEventListener('click', () => this.step(1));
      this.optionSelects.forEach((sel) => sel.addEventListener('change', () => this.onOptionChange()));
    }

    step(delta) {
      const current = parseInt(this.qtyInput.value, 10) || 1;
      this.qtyInput.value = Math.max(1, current + delta);
    }

    onOptionChange() {
      if (!this.variantSelect || this.variantSelect.tagName !== 'SELECT') return;
      const chosen = this.optionSelects.map((s) => s.value);
      const match = Array.from(this.variantSelect.options).find((opt) => {
        return opt.textContent.trim() === chosen.join(' / ');
      });
      if (match) {
        this.variantSelect.value = match.value;
        this.updatePrice(match);
        // A variant exists for this combo; it's sold out when its option
        // carries the server-rendered `disabled` attribute.
        this.setPurchasable(!match.disabled, match.disabled
          ? this.dataset.textSoldOut : this.dataset.textAdd);
      } else {
        // No variant exists for this combo (sparse option matrix — e.g. the
        // foil exists only in one border). Block the cart: the hidden select
        // still holds the PREVIOUS variant, so submitting would add the
        // wrong item.
        this.setPurchasable(false, this.dataset.textUnavailable);
      }
    }

    setPurchasable(purchasable, label) {
      const btn = this.querySelector('.product__atc');
      if (btn) {
        btn.disabled = !purchasable;
        const span = btn.querySelector('span');
        if (span && label) span.textContent = label;
      }
      const availability = document.getElementById('availability-' + this.dataset.section);
      if (availability) {
        availability.textContent = purchasable
          ? this.dataset.textInStock
          : (label === this.dataset.textUnavailable
              ? this.dataset.textUnavailable : this.dataset.textSoldOut);
      }
    }

    updatePrice(option) {
      // Price markup is server-rendered once for the first variant; swap it
      // to the resolved variant's price (Liquid `money`-formatted via the
      // option's data attributes, so no client-side currency formatting).
      const priceEl = document.getElementById('price-' + this.dataset.section);
      if (!priceEl || !option.dataset.price) return;
      while (priceEl.firstChild) priceEl.removeChild(priceEl.firstChild);
      if (option.dataset.compareAt) {
        const del = document.createElement('del');
        del.textContent = option.dataset.compareAt;
        priceEl.appendChild(del);
        priceEl.appendChild(document.createTextNode(' '));
      }
      priceEl.appendChild(document.createTextNode(option.dataset.price));
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  } catch(e) { console.error(e); }
})();
})();
